import { Color } from '@diritto/common/style/color';
import { NewIconProps } from '@diritto/common/style/icon';

export const ReplyIcon = ({ className, color = Color.Gray700, opacity = 1 }: NewIconProps) => (
  <svg
    className={className}
    width="100%"
    height="100%"
    opacity={opacity}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 21C8.73478 21 8.48043 20.8946 8.29289 20.7071C8.10536 20.5196 8 20.2652 8 20V17H4C3.46957 17 2.96086 16.7893 2.58579 16.4142C2.21071 16.0391 2 15.5304 2 15V5C2 3.89 2.9 3 4 3H20C20.5304 3 21.0391 3.21071 21.4142 3.58579C21.7893 3.96086 22 4.46957 22 5V15C22 15.5304 21.7893 16.0391 21.4142 16.4142C21.0391 16.7893 20.5304 17 20 17H13.9L10.2 20.71C10 20.9 9.75 21 9.5 21H9ZM10 15V18.08L13.08 15H20V5H4V15H10Z"
      fill={color}
    />
  </svg>
);
